import type { ServiceOption } from '../../types';

export enum DisplayCredentialsType {
  OWNER = 'owner',
  IDS = 'ids',
  SECRETS = 'secrets',
  SETTINGS = 'settings',
}

export interface ServiceCredentialsOnChangePayload extends EventTarget {
  id: ServiceOption['key'];
  value: ServiceOption['value'];
}

export enum ChangeOwnerCondition {
  CUSTOMER_AGENT_TO_CUSTOMER = 'customerAgentToCustomer',
  NO_OWNER = 'noOwner',
  DEFAULT = 'default',
}
